import { render } from "./TemaTransportOgMobilitet.vue?vue&type=template&id=237279f4"
import script from "./TemaTransportOgMobilitet.vue?vue&type=script&lang=js"
export * from "./TemaTransportOgMobilitet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__